import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles, Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CallToAction = () => {
  const navigate = useNavigate();

  const scrollToHero = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    
    // Focus the input field in the hero section after scrolling
    setTimeout(() => {
      const textareaElement = document.querySelector('.hero-textarea') as HTMLTextAreaElement;
      if (textareaElement) {
        textareaElement.focus();
      }
    }, 800);
  };

  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-background/90"></div>
        <div className="absolute top-0 left-0 w-full h-full glass opacity-50"></div>
        <div className="absolute top-20 left-20 w-72 h-72 bg-purple-600/20 rounded-full filter blur-3xl opacity-30"></div>
        <div className="absolute bottom-40 right-10 w-80 h-80 bg-indigo-600/20 rounded-full filter blur-3xl opacity-20"></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mx-auto text-center"
        >
          <div className="inline-block mb-6 p-2 rounded-full bg-white/5 border border-white/10">
            <Zap className="w-6 h-6 text-purple-400" />
          </div>
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 font-display leading-tight">
            From Raw Ideas to <br />
            <span className="bg-gradient-to-r from-purple-500 to-indigo-500 bg-clip-text text-transparent">
              Production Code
            </span>
          </h2>
          
          <p className="text-xl text-muted-foreground mb-8">
            Transform your development workflow with AI-powered code generation. Our advanced prompting system helps you create production-ready code, handle complex refactoring, and solve challenging bugs with unprecedented efficiency.
          </p>
          
          <button 
            onClick={scrollToHero}
            className="bg-gradient-to-r from-purple-600 to-indigo-600 px-8 py-4 text-lg shadow-lg shadow-indigo-700/20 flex items-center gap-2 mx-auto group rounded-lg hover:opacity-90 transition-opacity"
          >
            <Sparkles className="w-5 h-5" />
            Start Coding Smarter
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
          
          <div className="mt-12 flex flex-wrap justify-center gap-8 text-center">
            <div className="flex flex-col items-center">
              <div className="text-4xl font-bold text-white mb-2">80%</div>
              <div className="text-muted-foreground">Time Saved</div>
            </div>
            <div className="flex flex-col items-center">
              <div className="text-4xl font-bold text-white mb-2">100%</div>
              <div className="text-muted-foreground">Production Ready</div>
            </div>
            <div className="flex flex-col items-center">
              <div className="text-4xl font-bold text-white mb-2">24/7</div>
              <div className="text-muted-foreground">AI Support</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CallToAction;
